import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "./ui/button";

/**
 * Shown when data fetch fails — clearly distinct from "no data" empty states.
 * Always includes a retry action so users can recover.
 */
export function FetchErrorState({ onRetry, message }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center" data-testid="fetch-error-state">
      <div className="w-12 h-12 rounded-full bg-amber-50 dark:bg-amber-950/30 flex items-center justify-center mb-4">
        <AlertTriangle className="w-6 h-6 text-amber-500" />
      </div>
      <p className="font-medium text-foreground mb-1">Couldn't load your data</p>
      <p className="text-sm text-muted-foreground mb-4 max-w-sm">
        {message || "Something went wrong. Your data is safe — this is just a loading issue."}
      </p>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry} data-testid="retry-fetch-btn">
          <RefreshCw className="w-4 h-4 mr-2" />
          Try again
        </Button>
      )}
    </div>
  );
}
